// IMPORTS
// Assets
import BarGauge from './BarGauge';


// COMPONENT
export default function UsageByPortType (props) {
   // Component
   return (
      <div className='oneport-dashboard-usagebyporttype oneport-dashboard-bargraph'>
         {props.parent.usageByPortType && props.parent.usageByPortType.length > 0 && props.parent.usageByPortType.map(function (item, i) {
            return (
               <BarGauge key={`oneport-dashboard-usagebyporttype-${i}`} title={item.type} current={item.current} max={item.max} />
            );
         })}
      </div>
   );
}